<template>
  <div class="temperature-animations">
    <div class="hidden sm:block">
      <img
        src="../../assets/AirCompModule.gif"
        class="gif1"
      >
    </div>
    <div class="hidden sm:block">
      <img
        src="../../assets/RelativeHumModule.gif"
        class="gif2"
      >
    </div>

    <div class="hidden sm:block">
      <img
        src="../../assets/PowerUsageModule.gif"
        class="gif3"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemperatureAnimations',
}
</script>

<style lang="postcss" scoped>
.temperature-animations {
  bottom: 20px;
  left: 0;
  @apply flex items-end justify-between text-blue absolute p-16 w-full select-none;
}

.gif1 {
  max-width: 280px;
}

.gif2 {
  max-height: 180px;
  max-width: 331px;
}

.gif3 {
  max-width: 449px;
}
</style>
